import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CTA_LABEL } from '../data/offer';
// Dorado brilloso (metal pulido) aplicado inline para garantizar el acabado.
const GOLD_STYLE: React.CSSProperties = {
  backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.18) 44%, rgba(255,255,255,0) 50%), linear-gradient(180deg, #FFF4B8 0%, #FFD94A 24%, #F6B81A 50%, #D88C08 72%, #F7C12C 88%, #FFE681 100%)',
  boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.95), inset 0 -3px 4px rgba(150,90,0,0.45), 0 0 0 1px #B07A12, 0 0 24px rgba(255,196,40,0.6), 0 14px 28px -12px rgba(160,100,10,0.85)'
};
type CtaButtonProps = {
  href?: string;
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  href = '#comprar',
  label = CTA_LABEL,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 sm:px-8 text-[13px] sm:text-[15px]' : 'px-5 py-3 text-xs sm:text-sm';
  return <a href={href} style={GOLD_STYLE} className={`group inline-flex items-center justify-center gap-3 btn-gold rounded-full text-center font-bold uppercase tracking-[0.03em] text-petrol-900 [text-shadow:0_1px_0_rgba(255,245,210,0.6)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${sizing} ${className}`} data-id="element-32" data-mp="35xflv08vct74">
      <span className="relative z-10 text-balance" data-id="element-33" data-mp="3owa26dnze1pe">{label}</span>
      <ArrowRightIcon className="relative z-10 h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-34" data-mp="3ovrzay6tcp8i" />
    </a>;
}